import React, { useState, useEffect } from 'react';
import { useTheme, createUseStyles } from 'react-jss';
import classNames from 'classnames';
import Icon from '@mdi/react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';
import * as R from 'ramda';
import { useParams } from 'react-router';

import { mdiWechat, mdiSinaWeibo, mdiEarth } from '@mdi/js';

import Container from '@components/Container';
import Loading from '@components/Base/Loading';
import Logo from '@asserts/images/products/logo_vechain.png';

import { getCustomData } from '@utils/Analysis';
import { fetch } from '@utils/fetch';

const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    position: 'relative',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: [rem(10), rem(20)],
    backgroundColor: 'rgba(33, 34, 38, 1)',
  },
  sign: {
    fontSize: rem(30),
    color: 'rgba(38, 38, 38, 1)',
  },
  icons: {
    width: '35%',
    '& > a': {
      color: '#FFF',
    }
  },
  icon: {
    width: 28,
    height: 28,
    padding: rem(5),
    borderRadius: '50%',
  },
  line: {
    width: '100%',
    fontSize: 18,
    margin: [rem(10), 0],
    color: 'rgba(255, 255, 255, 1)',
  },
  qrBox: {
    display: 'none',
    position: 'absolute',
    bottom: rem(100),
    padding: 8,
    right: '20%',
    border: '1px solid #CCC',
    backgroundColor: '#FFF',
    borderRadius: 10,
  },
  loading: {
    color: '#000',
    margin: rem(15),
  },
  show: {
    display: 'block',
  }
}), {
  name: 'Footer'
})

const Footer = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { t, data } = props;
  const router = useParams();
  
  const [isShow, setIsShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const custom = getCustomData(data);
  const social = R.pathOr({}, ['socialchannel'])(custom);
  const wechat = R.pathOr('', ['wechatimage', 'filelocation'])(social);

  const [wechatImage, setWechatImage] = useState(wechat);

  // 二维码图片有效期为1分钟
  useEffect(() => {
    if (isShow) {
      setLoading(true);
      const params = {
        vid: router.id,
        types: [
          'customizedDisplayInfo',
        ],
        language: 'zh'
      };
      fetch(params).then((data) => {
        const custom = getCustomData(data);
        const social = R.pathOr({}, ['socialchannel'])(custom);
        const wechat = R.pathOr('', ['wechatimage', 'filelocation'])(social);
        setWechatImage(wechat);
        setLoading(false);
      }, (err) => {
        console.log(err, '请求二维码图片数据失败');
        setWechatImage('请求失败');
        setLoading(false);
      });
    }
  }, [isShow, router]);

  const handleClickWechat = () => {
    setIsShow(!isShow);
  }

  return (
    <footer className={classNames(classes.root)}>
      <Container 
        flex 
        justify='space-between' 
        alignItems='center'
        style={{ width: '100%' }}
      >
        <img src={Logo} alt="logo"  width={130} />

        <Container
          flex
          justify='space-between'
          className={classes.icons}
        >
          <Icon
            path={mdiWechat}
            size={0.5}
            onClick={handleClickWechat}
            className={classNames(classes.icon)}
          />
          <a href={social.weibolink} rel='noreferrer'>
            <Icon
              path={mdiSinaWeibo}
              size={0.5}
              className={classNames(classes.icon)}
            />
          </a>
          <a href={social.homewebsite} rel='noreferrer'>
            <Icon
              path={mdiEarth}
              size={0.5}
              className={classNames(classes.icon)}
            />
          </a>
        </Container>
      </Container>

      <Container flex justify='flex-end' className={classes.line}>{t('hotline')} : {social.hotline}</Container>

      <Container 
        flex
        className={classNames(classes.qrBox, isShow && classes.show)}
      >
        {
          loading ? (
            <Loading 
              size={0.5}
              className={classes.loading}
            />
          ) : (
            <QRCode
              className={classNames(classes.qrCode)}
              value={wechatImage}
              size={100}
              level='M'
              bgColor='#ffffff'
              id='canvas'
            />
          )
        }
      </Container>
    </footer>
  )
};

Footer.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object,
}

export default Footer;
